import * as React from "react";
import { useParams, Link } from "react-router";

const CheckoutEmpty = () => {
    const { providerid } = useParams()
    return (
        <div className="container py-3">
            <h3>Cart Empty</h3>
            <div className="alert alert-info">
                Your cart is empty. <Link to={`/provider/${providerid}`}>Click here to view available programs.</Link>
            </div>
        </div>
    );
};

export default CheckoutEmpty;
